module.exports = __webpack_public_path__ + "img/profileCover.e3bbde4a.png";